import { render, staticRenderFns } from "./AgendaWebApp.vue?vue&type=template&id=68a6b9a8&"
import script from "./AgendaWebApp.vue?vue&type=script&lang=js&"
export * from "./AgendaWebApp.vue?vue&type=script&lang=js&"
import style0 from "./AgendaWebApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports